<template>
<div>
	<el-upload
    ref="uploadRef"
		action="www"
		:drag="drag"
		class="form-item-upload"
		:http-request="httpRequest"
		:on-success="handleSuccess"
    :on-error="handleError"
    :on-change="handleChange"
		:before-upload="beforeUpload"
    :on-exceed="handleExceed"
		:multiple="multiple"
    :limit="limit"
		:accept="accept"
		:show-file-list="fileListShow"
    :file-list="fileList"
	>
		<slot />
	</el-upload>
  <!-- 进度条 -->
  <div v-if="progress.visible" style="z-index:9999;width: 100%;height: 100%;position: fixed;left: 0;top: 0;background: rgba(74, 74, 74, 0.4)" @click.stop>
    <div _pos="fixed" _z="2009" style="top:50%;left:50%;transform: translate(-50%, -50%);z-index:4000" _w="250px">
      <div _text="20px [#ff5e2a] bolder" _m="b-10px"><i class="el-icon-loading" _m="r-5px"/>{{ progress.msg }}</div>
      <el-progress :percentage="parseInt(fake.progress * 100)" _h="40px" :stroke-width="18" :text-inside="true"></el-progress>
    </div>
  </div>
</div>
</template>
<script>
import CryptoJS from 'crypto-js'
import Fakeprogress from 'fake-progress'
import MediaInfoFactory from 'mediainfo.js'

export default {
	props: {
    limit: Number,
		drag: {
			type: Boolean,
			default: false
		},
		echoFile: Array,
		fileListShow: {
			type: Boolean,
			default: true
		},
		multiple: {
			type: Boolean,
			default: false
		},
		accept: {
			type: String,
			default: ''
		},
		fileUrlData: {
			type: [Array, Object]
		},
		customUpload: Function,
		deleteUpload: Function
	},
	data() {
		return {
      fake: new Fakeprogress({
				timeConstant: 6000
			}),
      analysis: '',
      progress: {
        num: 0,
        visible: false,
        msg: '正在上传中...'
      },
      progressTimer: null,
      fileList: []
		}
	},
	watch: {
    fileUrlData: {
      handler(update) {
        // const { uploadFiles } = this.$refs.uploadRef
        // if (uploadFiles && uploadFiles.length) {
        //   uploadFiles.splice(0, uploadFiles.length - update.length)
        // }
      },
      deep: true
    },
	},
  mounted() {
    this.$on('remove-file', this.remove);
  },
  destroyed() {
    this.$off('remove-file', this.remove);
  },
	methods: {
    remove(index) {
      this.fileList.splice(index, 1)
    },
    handleChange(file, fileList) {
      this.fileList = [...fileList]
    },
    handleExceed() {
      this.$message.error('最多支持9个文件')
    },
    async beforeUpload(file) {
      this.analysis = ''
      file.analysis = ''
      const fileType = file.type.split('/')[1]

      if (fileType === 'x-ms-wmv') {
        this.analysis = file.analysis = 'transcode'
        return
      }

      if (!this.isMp4File(file)) {
        return
      }

      const codec = await this.getVideoCodec(file)
      if (codec && !this.isSupportedCodec(codec)) {
        this.analysis = file.analysis = 'transcode'
      }
    },
    fetchHash(data) {
      const blockSize = 1024 * 1024 * 10
      let wordArray
      const hash = CryptoJS.algo.MD5.create()
      for (let i = 0; i < data.byteLength; i += blockSize) {
        const end = Math.min(i + blockSize, data.byteLength)
        const chunk = data.slice(i, end)
        wordArray = CryptoJS.lib.WordArray.create(Array.from(new Uint8Array(chunk)))
        hash.update(wordArray)
      }
      return hash.finalize().toString()
    },
		readBlobAsArrayBuffer(file) {
			return new Promise(resolve => {
				const reader = new window.FileReader()
				reader.onload = event => resolve(event.target.result)
				reader.readAsArrayBuffer(file)
			})
		},
    isMp4File(file) {
      const name = file.name || ''
      const type = file.type || ''
      return type === 'video/mp4' || /\.mp4$/i.test(name)
    },
    readFileChunk(file, chunkSize, offset) {
      return new Promise((resolve, reject) => {
        const reader = new window.FileReader()
        reader.onload = () => resolve(new Uint8Array(reader.result))
        reader.onerror = () => reject(new Error('media info read failed'))
        reader.readAsArrayBuffer(file.slice(offset, offset + chunkSize))
      })
    },
    async getMediaInfo(file) {
      let mediainfo
      try {
        mediainfo = await MediaInfoFactory({
          locateFile: path => `${process.env.BASE_URL}${path}`
        })
        return await mediainfo.analyzeData(
          () => file.size,
          (chunkSize, offset) => this.readFileChunk(file, chunkSize, offset)
        )
      } catch (_) {
        return null
      } finally {
        if (mediainfo) {
          mediainfo.close()
        }
      }
    },
    isSupportedCodec(codec) {
      return codec.match(/AVC|H\.264|VP9|VP8|AV1/i)
    },
    async getVideoCodec(file) {
      const info = await this.getMediaInfo(file)
      const tracks = info?.media?.track || []
      const videoTrack = tracks.find(track => track['@type'] === 'Video')
      return videoTrack?.Format || ''
    },
    async transcodeVideo(file, params) {
      this.progress.msg = '视频转码中...'
      const ret = await this.$api5.user.httpPost('imm', params).catch((_) => {})
      const message = '文件解析失败，请自行转码后上传。'
      if (ret?.status == 2) {
        return { node: ret?.node, uri: ret?.uri }
      }
      if (ret?.status != 1) {
        this.$message.error(`${file.name}: ${message}`)
        return false
      }
      let done = false
      for (;!done;) {
        await new Promise(resolve => setTimeout(resolve, 1500))
        const data = await this.$api5.user.httpPost('imm/status', { path: ret.path }).catch((_) => false)
        if (!data?.status) {
          this.$message.error(`${file.name} ${message}`)
          return false
        }
        if (data?.status === 2) {
          return { node: data?.node, uri: data?.uri }
        }
        if (data?.status === 0) {
          this.$message.error(`${file.name}: ${message}`)
          return false
        }
      }
    },
    async uploadFile(file, needTranscode = false) {
      this.progress.msg = '正在上传中...'
      this.fake.start()
      this.progress.visible = true
      let rf = await this.readBlobAsArrayBuffer(file)
      const MD5 = this.fetchHash(rf)
      const data = await this.$api3.question_set.upload({
        file_key: 'file',
        filename: file.name,
        hash: MD5,
        mime_type: file.type,
        size: file.size,
        temp_path: needTranscode ? '1' : '',
        storage: {
          channel: 'public'
        }
      })
      let res
      if (file.size / 1024 / 1024 > 2000) {
        let form = new FormData()
        form.append('file', file)
        res = await this.$api3.question_set.uploadFileForm(data.uri, form, { ...data.headers })
      } else {
        res = await this.$api3.question_set.uploadFile(data.uri, rf, { ...data.headers })
      }
      if (!res) {
        this.$message.error('文件上传失败')
        return false
      }
      if (!needTranscode) {
        return { node: res.node, uri: res.uri }
      }
      else {
        const uploadedPath = res.node.replace(/^public\:/g, '')
        const result = await this.transcodeVideo(file, { path: uploadedPath, ext: file.name.replace(/^\./, '') })
        return result
      }
    },
    async httpRequest(file) {
      const needTranscode = file.file.analysis === 'transcode'
      const result = await this.uploadFile(file.file, needTranscode)
      if (!result) throw new Error('upload failed')
      return result
    },
		async handleSuccess(response, file) {
      const name = file.name?.replace(/\.([^.]+)$/, '')
			if (this.customUpload) {
				this.customUpload({ response, fileType: file.raw.type.split('/')[0], name: name })
			} else {
				this.$emit('customUpload', { response, fileType: file.raw.type.split('/')[0], name: name })
			}
      await new Promise(resolve => setTimeout(resolve, 1000))
      const allSuccess = this.fileList.every(item => item.status === 'success')
      if (allSuccess) {
        this.fake.end()
        this.fake = new Fakeprogress({
          timeConstant: 6000
        })
        this.progress.visible = false
      }
		},
    handleError() {
      const allFail = this.fileList.every(item => item.status === 'fail')
      if (allFail) {
        this.fake.end()
        this.fake = new Fakeprogress({
          timeConstant: 6000
        })
        this.progress.visible = false
      }
    },
	}
}
</script>
<style lang="scss">
.form-item-upload {
	width: 200px;
}
</style>
